<p-blockUI [blocked]="loading" >
    <p-progressSpinner [style]="{width: '70px', height: '70px', display: 'block', 'margin-left':'auto', 'margin-right':'auto', 'margin-top':'250px'}" strokeWidth="8" fill="#EEEEEE" animationDuration="1.5s"></p-progressSpinner>
</p-blockUI>
<div class="p-grid" style="margin: 30px;" #body>
    
    <p-panel header="LISTE DES FICHES EN ATTENTE D'ENVOI" class="p-col-12">
        <p-table #dt [rowHover]="true" [rowsPerPageOptions]="[10,25,50]" styleClass="ui-table-customers" [columns]="envoiCols" [value]="envoiData" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes">
            <ng-template pTemplate="caption">
                
            </ng-template>

            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of envoiCols" [pSortableColumn]="col.field">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" ></p-sortIcon>
                    </th>

                    <th style="width: 100px; text-align: center;">Envoyer</th>
                    <th style="width: 100px; text-align: center;">Visualiser</th>

                </tr>
                <tr>
                    <th *ngFor="let col of envoiCols" [ngSwitch]="col.field">
                        <input *ngSwitchCase="'num_point_accueil'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
                    </th>
                    <th></th>
                    <th></th>
                </tr>

            </ng-template>

            <ng-template pTemplate="body" let-moderation let-columns="columns">
                <tr>
                    <td *ngFor="let col of columns">
                            <span [class]="(col.field === 'etat' && moderation[col.field] !== '') ? ((moderation[col.field] === 'KO CQ' ) ? 'customer-badge status-unqualified' : ((moderation[col.field] === 'EN ATTENTE MODERATION') ? 'customer-badge status-negotiation' : 'customer-badge status-new') ) : ''">
                                {{moderation[col.field]}}
                            </span>
                    </td>
                    <td align="center"> <button   pButton type="button"  icon="pi pi-compass"  style="width: 55px;" (click)="envoyerFiche(moderation['id_moderation'])"></button> </td>
                    <td align="center"> <button   pButton type="button"  icon="pi pi-eye"  style="width: 55px;" (click)="previsualiser(moderation['id_moderation'])"></button> </td>

                    
                </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
                </tr>
            </ng-template>
        </p-table>
    </p-panel>
</div>